import type { Position } from '../types';
import { ASTRO_SIZE } from '../config';

export const applyTransform = (
  element: HTMLElement | null,
  position: Position,
  width: number = ASTRO_SIZE.WIDTH,
  height: number = ASTRO_SIZE.HEIGHT,
): void => {
  if (!element) {
    return;
  }

  const left = position.x - width / 2;
  const top = position.y - height / 2;

  element.style.transform = `translate3d(${left}px, ${top}px, 0)`;
};
